module.exports = __webpack_public_path__ + "img/book-module-fight-info.b16fdf67.png";